import { render, staticRenderFns } from "./left_jaw.vue?vue&type=template&id=18f3e2d7"
import script from "./left_jaw.vue?vue&type=script&lang=js"
export * from "./left_jaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports